import { FORM_ANSWERS_LIST, PUBLISHED_FORM, CREATE_FORM_ANSWER, FORMS_PUBLISHED_LIST,
  PORTAL_FORMS_GET_SCHEMA, GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD, CLEAR_LOADING_ACTIONS, FORM_ANSWER_DETAILS,
  APPROVE_FORM_ANSWER, REJECT_FORM_APPROVAL, PORTAL_APPROVAL_SEND_BACK, SAVE_FORMS_VIEW_TAB,
  CLEAR_FORM_DETAILS, UPDATE_FORM_ANSWER, PORTAL_FORMS_GET_APPROVALS_LIST, GET_SELECTED_USERS,
  DELETE_FORM_ANSWER, FETCH_DATA_SOURCE_FORM_DETAILS, PORTAL_APPROVAL_SEND_BACK_WITH_DATA } from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchFormAnswers = (start_date, end_date, query, sort) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_forms/?
${start_date ? 's=' : ''}${start_date || ''}
${end_date ? '&f=' : ''}${end_date || ''}
${query ? '&search_query=' : ''}${query || ''}
${sort ? '&sort=' : ''}${sort || ''}`,
    ...FORM_ANSWERS_LIST
  }
});

export const fetchPublishedForm = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_forms/${id}/published_form/`,
    ...PUBLISHED_FORM
  }
});

export const createFormAnswer = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/portal_forms/${id}/create_form_answer/`,
    data,
    ...CREATE_FORM_ANSWER
  }
});

export const getAllPublishedFormList = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_forms/get_published_forms/',
    ...FORMS_PUBLISHED_LIST
  }
});


export const getPortalFormSchema = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/portal_forms/get_schema/?form_key=${id}`,
    ...PORTAL_FORMS_GET_SCHEMA
  }
});

export const getPortalusersForPortaUserlField = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/users/get_portal_users/',
    ...GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD
  }
});


export const fetchFormAnswerDetails = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_forms/${id}/`,
    ...FORM_ANSWER_DETAILS
  }
});

export const clearFormActions = data => ({
  type: CLEAR_LOADING_ACTIONS,
  payload: { ...data }
});


export const submitApproval = (data, id) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_form_approval/${id}/create_form/`,
    data,
    ...APPROVE_FORM_ANSWER
  }
});

export const rejectApproval = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_form_approval/${id}/reject_approval/`,
    data,
    ...REJECT_FORM_APPROVAL
  }
});

export const approvalSendBack = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_form_approval/${id}/send_back/`,
    data,
    ...PORTAL_APPROVAL_SEND_BACK
  }
});

export const approvalSendBackWithData = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_form_approval/${id}/send_back_with_data/`,
    data,
    ...PORTAL_APPROVAL_SEND_BACK_WITH_DATA
  }
});

export const getMyPendingApprovalList = getCompletedList => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/portal_form_approval/get_user_approvals/${getCompletedList ? '?completed=true' : ''}`,
    ...PORTAL_FORMS_GET_APPROVALS_LIST
  }
});

export const actionSaveTabView = data => ({
  type: SAVE_FORMS_VIEW_TAB,
  payload: data
});

export const actionClearForm = () => ({
  type: CLEAR_FORM_DETAILS
});

export const editFormAnswer = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/portal_forms/${id}/`,
    data,
    ...UPDATE_FORM_ANSWER
  }
});

export const fetchselectedUsers = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/users/get_dropdown_users/',
    ...GET_SELECTED_USERS
  }
});

export const fetchDataSourceFormDetails = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_forms/${id}/`,
    ...FETCH_DATA_SOURCE_FORM_DETAILS
  }
});

export const deletePortalDraftForm = id => ({
  type: BACKEND_API,
  payload: {
    method: 'DELETE',
    url: `/portal_forms/${id}/`,
    ...DELETE_FORM_ANSWER
  }
});
